import useCollectPayment from './useCollectPayment';

export default useCollectPayment;
